module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "widgets",
    attrs: {
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.widgetTitle))]), _vm._v(" "), _c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Click on the different coloured segments to view the corresponding data in your quote report.")])]), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.graphData.headers,
      "items": _vm.graphData.rows
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.quote_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.conversion_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.conversion_rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.quote_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.sales_value))])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('dialog-filter-config', {
    attrs: {
      "fc-key": "quote_val_per_rep",
      "widget-title": _vm.widgetTitle
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}